export default __webpack_public_path__ + "static/media/Watergate.bf76277c.png";